import { IDBHandler, IExternalConfig } from '@/types';

export interface IServiceLocator {
    externalConfig?: IExternalConfig;
    dbHandler?: IDBHandler;
}

export const serviceLocator = {};
